import { jsx as _jsx } from "react/jsx-runtime";
import React, { memo } from "react";
import { getCardImage } from "@shared/blocks/helpers";
import "./view.scss";
export const VideoBlockView = memo(({ block }) => {
    const imageUrl = getCardImage(block);
    return imageUrl ? (_jsx("div", { className: "image-container", children: _jsx("img", { src: imageUrl, alt: "Video thumbnail" }) })) : (_jsx("span", { className: "light-text", children: "Video" }));
});
